import { BelongsToReferenceField, pageCollectionFields } from 'drapcode-constant';
import { fieldTraitProgressBarOptions, fieldTraitTextContentOptions } from './traitsApi';
export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pageCollection, pfx, collections, projectId } = opts;
  domc.addType('data-group', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Data Group',
          resizable: 1,
          collectionName: '',
          collectionFrom: '',
          icon: '<i class="wb webconnect-list-task"></i>',
          finderUuid: '',
          whenEmpty: '',
          numberPerPage: 10,
          projectId: projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          traits: [
            {
              type: 'data-group-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'Records Per Page',
              name: 'numberPerPage',
              changeProp: 1,
              value: '{[numberPerPage]}',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';
            const fieldName = '{[ fieldName ]}';
            const recordsPerPage = '{[ numberPerPage ]}';
            let collectionFrom = '{[ collectionFrom ]}';
            let sessionDataPath = '{[ sessionDataPath ]}';

            let selectedCollectionData = '{[ selectedCollectionStr ]}';
            selectedCollectionData = selectedCollectionData.replaceAll('**##', '"');
            const externalQueryParamKeys = [];
            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              selectedCollectionData = JSON.parse(selectedCollectionData);
              const selectedFilter = selectedCollectionData.finders.find(
                (finder) => finder.uuid === finderId,
              );

              if (selectedFilter && selectedFilter.conditions) {
                selectedFilter.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const {
                      query: { value },
                    } = condition;
                    if (value.includes('---')) {
                      const values = value.split('---');
                      externalQueryParamKeys.push(values[0]);
                      externalQueryParamKeys.push(values[1]);
                    } else {
                      externalQueryParamKeys.push(value);
                    }
                  }
                });
              }
            }

            const dataGroup = this.cloneNode(true);
            let paginationData = {};
            paginationData.numberPerPage = recordsPerPage ? recordsPerPage : 5;
            paginationData.filteredItemsUrl = `collection-table/${collectionId}/finder/${finderId}/items`;
            paginationData.dataGroupChildren = dataGroup ? dataGroup.children : [];
            paginationData.currentPage = 1;
            paginationData.currentDateRange = 0;
            paginationData.dataGroup = this;
            paginationData.numberOfPages = 0;
            paginationData.finderId = finderId;
            paginationData.collectionName = collectionId;
            paginationData.fieldName = fieldName;
            paginationData.externalQueryParamKeys = externalQueryParamKeys;
            paginationData.browserSessionDataPath = sessionDataPath;

            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              paginationData.externalApiId = selectedCollectionData.externalApiId;
              paginationData.responseDataMapping = selectedCollectionData.responseDataMapping;
              paginationData.bodyDataFrom = selectedCollectionData.bodyDataFrom;
              paginationData.sendFormData = !!selectedCollectionData.sendFormData;
            }

            if (
              !['externalAPIResponse', 'browserSession', 'typesenseCollection'].includes(
                collectionFrom.trim(),
              ) &&
              typeof loadDataGroupItems !== 'undefined'
            ) {
              loadDataGroupItems(paginationData, this);
            }

            if (
              collectionFrom.trim() === 'externalAPIResponse' &&
              typeof loadDataGroupFromExternalAPI !== 'undefined'
            ) {
              console.log('*** Loading DataGroup from External API...');
              loadDataGroupFromExternalAPI(paginationData, this);
            }

            if (
              collectionFrom.trim() === 'browserSession' &&
              typeof loadDataGroupFromBrowserSession !== 'undefined'
            ) {
              console.log('*** Loading DataGroup from Browser Session...');
              loadDataGroupFromBrowserSession(paginationData);
            }
            if (
              collectionFrom.trim() === 'typesenseCollection' &&
              typeof loadDataGroupItems !== 'undefined'
            ) {
              loadDataGroupItems(paginationData, this, true);
            }

            const pagination = this.querySelector('[data-gjs=pagination]');
            const search = this.querySelector('.search-form');
            const dateRangeFilterIndex = this.querySelector('.date-range-filter');
            if (search) {
              search.addEventListener('submit', function (ev) {
                ev.preventDefault();
                let forNonPersistentData = false;
                if (
                  collectionFrom.trim() === 'externalAPIResponse' &&
                  typeof loadDataGroupFromExternalAPI !== 'undefined'
                ) {
                  console.log('*** Search in DataTable for Non Persistent Data... ');
                  forNonPersistentData = true;
                }
                paginationData['event'] = ev;
                searchInDataGroup(paginationData, forNonPersistentData);
              });

              const enableAutoSearch = search.hasAttribute('data-enableautosearch');
              if (typeof autoSearchInDataSearch !== 'undefined') {
                autoSearchInDataSearch(enableAutoSearch, search);
              }
            }
            if (dateRangeFilterIndex && typeof dateRangeDataGroupNav !== 'undefined') {
              console.log('*** Loading dateRangeDataGroupNav...');
              dateRangeDataGroupNav(paginationData);
            }
            console.log('🚀 *** Loading DataGroup ~ pagination:', pagination);
            if (pagination) {
              const loadMore = pagination.querySelector('.loadMore');
              const next = pagination.querySelector('.next');
              const previous = pagination.querySelector('.previous');
              const first = pagination.querySelector('.first');
              const last = pagination.querySelector('.last');
              if (next) {
                next.addEventListener('click', function (ev) {
                  ev.preventDefault();
                  nextDataGroupPage(paginationData);
                });
              }
              if (first) {
                first.addEventListener('click', function (ev) {
                  ev.preventDefault();
                  firstDataGroupPage(paginationData);
                });
              }
              if (last) {
                last.addEventListener('click', function (ev) {
                  ev.preventDefault();
                  lastDataGroupPage(paginationData);
                });
              }
              if (previous) {
                previous.addEventListener('click', function (ev) {
                  ev.preventDefault();
                  previousDataGroupPage(paginationData);
                });
              }
              if (loadMore) {
                loadMore.addEventListener('click', function (ev) {
                  ev.preventDefault();
                  loadMoreRecords(paginationData);
                });
              }
            }
          },
        },
        init() {
          //Populate Previous External Query from Collection Finder
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              pageCollectionFields.includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
        },
        findCustomType(type) {
          const result = [];
          const find = (components) =>
            components.forEach((item) => {
              //Changed to find type
              item.get('custom-type') === type && result.push(item);
              find(item.components());
            });
          find(this.components());
          return result;
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const textTraitTargets = this.findCustomType('text');
          const imageTraitTargets = this.findCustomType('image');
          const formElements = this.findCustomType('form-control');
          const hrefTraitTargets = this.findType('link');
          const progressBarTraitTargets = this.findType('progress');
          const dataGroupMapTraitTargets = this.findType('data-group-map');
          const searchForm = this.findType('search-form');
          const childDataGroup = this.findType('child-data-group');
          const childDataList = this.findType('child-data-list');
          const marketPlaceForm = this.findType('marketplace-form');
          if (searchForm.length > 0) {
            searchForm.map((component) => component.set('collectionName', collectionName));
          }
          if (childDataGroup.length > 0) {
            childDataGroup.map((component) =>
              component.set('parentSelectedCollection', collection),
            );
          }
          //TODO: Need if required
          if (childDataList.length > 0) {
            childDataList.map((component) => component.set('parentSelectedCollection', collection));
          }

          const textTraitsOptions = await fieldTraitTextContentOptions(collection, collections);
          const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collection);
          if (marketPlaceForm.length > 0) {
            marketPlaceForm.map((component) => {
              component.set('collectionName', collectionName);
              component.getTrait('quantityfield').set({
                options: numberFieldTraitsOptions,
              });
              component.getTrait('pricefield').set({
                options: numberFieldTraitsOptions,
              });
            });
          }
          if (textTraitTargets.length > 0) {
            textTraitTargets.map((component) => component.set('selectedCollection', collection));
          }
          if (imageTraitTargets.length > 0) {
            imageTraitTargets.map((component) => component.set('selectedCollection', collection));
          }
          if (formElements.length > 0) {
            formElements.map((component) => component.set('selectedCollection', collection));
          }
          if (hrefTraitTargets.length > 0) {
            hrefTraitTargets.map((component) =>
              component.set('selectedCollection hrefTraitTargets', collection),
            );
          }
          if (progressBarTraitTargets.length > 0) {
            progressBarTraitTargets.map((component) => {
              component.removeTrait('data-progress-now');
              component.removeTrait('data-progress-min');
              component.removeTrait('data-progress-max');
              component.addTrait({
                name: 'data-progress-now',
                label: false,
                options: numberFieldTraitsOptions,
                title: `Get Now From ${collection.collectionTitle}`,
                type: 'data-progress-now',
                changeProp: 1,
              });
              component.addTrait({
                name: 'data-progress-min',
                label: false,
                options: numberFieldTraitsOptions,
                title: `Get Min From ${collection.collectionTitle}`,
                type: 'data-progress-min',
                changeProp: 1,
              });
              component.addTrait({
                name: 'data-progress-max',
                label: false,
                options: numberFieldTraitsOptions,
                title: `Get Max From ${collection.collectionTitle}`,
                type: 'data-progress-max',
                changeProp: 1,
              });
            });
          }
          if (dataGroupMapTraitTargets.length > 0) {
            dataGroupMapTraitTargets.map((component) => {
              component.removeTrait('data-group-map-lat');
              component.removeTrait('data-group-map-long');
              component.removeTrait('data-group-map-header');
              component.removeTrait('data-group-map-description');
              component.addTrait({
                name: 'data-group-map-lat',
                label: 'Latitude',
                options: numberFieldTraitsOptions,
                title: `latitude`,
                type: 'data-map-trait',
              });
              component.addTrait({
                name: 'data-group-map-long',
                label: 'Longitude',
                options: numberFieldTraitsOptions,
                title: `longitude`,
                type: 'data-map-trait',
              });
              component.addTrait({
                name: 'data-group-map-header',
                label: 'Header',
                options: textTraitsOptions,
                title: `header`,
                type: 'data-map-trait',
              });
              component.addTrait({
                name: 'data-group-map-description',
                label: 'Description',
                options: textTraitsOptions,
                title: `description`,
                type: 'data-map-trait',
              });
            });
          }
          const allTraits = this.get('traits');
          console.log('allTraits :>> ', allTraits);
          const removeTraits = [];
          allTraits.map((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
        },
        async handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.map((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'data-group') {
            return {
              type: 'data-group',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:collectionFrom', this.updateScript);
        this.listenTo(model, 'change:sessionDataPath', this.updateScript);
      },
    }),
  });
}
